import {LabelRegular, TextMedium} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import {AxiosError} from 'axios'
import React from 'react'

import {useCustomer} from '../../hooks/useCustomer'
import {useTranslation} from '../../hooks/useTranslation'

type RoleCustomerLookupChipProps = {
  customerId: string
  error?: Error
}

export const RoleCustomerLookupChip = ({customerId}: RoleCustomerLookupChipProps) => {
  const {t} = useTranslation()

  const customerQueryInfo = useCustomer({customerId})
  const customer = customerQueryInfo.data

  if (customerQueryInfo.isLoading) {
    return <CircularProgress size="20" />
  }

  if (customerQueryInfo.isError) {
    return (
      <div className="flex flex-col items-start">
        <TextMedium className="text-foreground">{customerId}</TextMedium>
        <TextMedium className="text-foreground">{t('manageUser.customer.error')}</TextMedium>
        <TextMedium className="text-foreground">
          {(customerQueryInfo.error as AxiosError).message}
        </TextMedium>
      </div>
    )
  }

  return (
    <div data-test-id="manageUser.customer" className="flex flex-col items-start">
      <LabelRegular className="text-foreground_faded">
        {t('manageUser.customer.title')}
      </LabelRegular>
      <TextMedium className="text-foreground">{customer?.customerName}</TextMedium>
      <LabelRegular className="text-foreground_faded">{customer?.customerNumber}</LabelRegular>
    </div>
  )
}
